// Kept outside React so HTTP errors can open prompts even after a stale UI check.
export const SUBSCRIPTION_GATE_EVENT = 'locumspace:subscription-gate';
export const SUBSCRIPTION_USAGE_EVENT = 'locumspace:subscription-usage';

export const handleSubscriptionError = (body: any) => {
  if (!['SUBSCRIPTION_FEATURE_REQUIRED', 'SUBSCRIPTION_LIMIT_REACHED', 'SUBSCRIPTION_ACCESS_UNAVAILABLE'].includes(body?.code)) return false;
  const features = ['canPostJobs', 'canApplyToJobs', 'canReceiveJobAlerts', 'canReceiveJobInvites', 'canUseFindLocum'];
  if (!features.includes(body.feature)) return false;
  window.dispatchEvent(new CustomEvent(SUBSCRIPTION_GATE_EVENT, {
    detail: { ...body, checkFailed: body.code === 'SUBSCRIPTION_ACCESS_UNAVAILABLE' },
  }));
  return true;
};
